import moment from 'moment'
export default {
  name: 'helperMethods',
  showNotification (context, title, message, type, duration, callInfo) {
    if (message === null || message === undefined || message === '') {
      message = 'no error message returned'
    }
    if (message.indexOf('unauthorized') === -1 && message.indexOf('Service down: connection refused') === -1) {
      var defaultNotifyMessage = message
      if (title === 'Refresh') {
        context.alertTitle = ''
        context.callInfo = ''
        context.alertType = ''
      } else {
        var browser = this.getBrowser()
        if (callInfo === undefined) {
          context.callInfo = message
        } else {
          context.callInfo = callInfo
        }
        context.alertTitle = title
        context.alertType = type
        if (type === 'error') {
          context.callInfo = 'If error continues after retry please contact Service desk with the following: Browser: ' + browser.name + ' ' + browser.version + ': ' + message.trim()
          if (message.indexOf('unauthorized') === -1 && message.indexOf('Service down: connection refused') === -1 &&
          message.indexOf(' cannot be viewed.') === -1) {
            defaultNotifyMessage = 'Please see error on page for more information.'
          } else {
            // hide error, login popup thrown
            context.alertTitle = ''
          }
        }
      }
      // only allow one message if deleted or not exists
      if (message.indexOf('PEA') === 0 && !(message.indexOf(' cannot be viewed.') === 1)) {
        context.$notify({
          title: title,
          message: defaultNotifyMessage,
          type: type,
          duration: duration
        })
      } else if (message.indexOf(' cannot be viewed.') <= 0) {
        context.$notify({
          title: title,
          message: defaultNotifyMessage,
          type: type,
          duration: duration
        })
      }
    }
  },
  convertDateToNumber (date) {
    // var year = date.GetYear()
    // var month = date.GetMonth()
    // var day = date.getDate()
    var val = moment(date).format('YYYYMMDD')
    return parseInt(val)
  },
  convertDatetoISO (date) {
    if (date !== undefined && date !== '') {
      var a = new Date(date)
      return a.toISOString()
    }
    return null
  },
  formatMoney (money) {
    if (money === undefined || money === null) {
      return '0.00'
    }
    money = parseFloat(money)
    return money.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
  },
  formatDate (date) {
    if (date === undefined || date === null) {
      return 'N/A'
    }
    return moment(date).format('MMM DD, YYYY')
  },
  formatPEAAuthorizationsDate (date) {
    if (date === undefined || date === null || date === '0001-01-01T00:00:00') {
      return 'N/A'
    }
    return moment(date).format('DD MMM YYYY h:mm A')
  },
  // https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
  base64toBlob (base64Data, contentType) {
    contentType = contentType || ''
    var sliceSize = 1024
    var byteCharacters = atob(base64Data)
    var bytesLength = byteCharacters.length
    var slicesCount = Math.ceil(bytesLength / sliceSize)
    var byteArrays = new Array(slicesCount)
    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize
      var end = Math.min(begin + sliceSize, bytesLength)
      var bytes = new Array(end - begin)
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0)
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes)
    }
    return new Blob(byteArrays, { type: contentType })
  },
  downloadBase64File (data, document, context, file, navigator) {
    var filename = file.name
    var contentType = ''
    try {
      contentType = data.headers.map['content-type'][0]
    } catch (ex) {
      contentType = data.headers.map['Content-Type'][0]
    }
    try {
      if (navigator.msSaveBlob) {
        var blob = this.base64toBlob(data.body, contentType)
        navigator.msSaveBlob(blob, filename)
      } else {
        var linkElement = document.createElement('a')
        linkElement.setAttribute('href', 'data:' + contentType + ';charset=utf-8;base64,' + data.body)
        linkElement.setAttribute('download', filename)
        linkElement.click()
      }
    } catch (ex) {
      this.showNotification(context, 'Error downloading CRI document', 'front end error: ' + ex.message, 'error', 30000)
    }
  },
  getBrowser () {
    // if in IE refresh page to help avoid wierd caching issues.
    navigator.browserSpecs = (function () {
      var ua = navigator.userAgent
      var tem
      var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || []
        return {
          name: 'IE',
          version: (tem[1] || '')
        }
      }
      if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/)
        if (tem != null) {
          return {
            name: tem[1].replace('OPR', 'Opera'),
            version: tem[2]
          }
        }
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']
      if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1])
      }
      return {
        name: M[0],
        version: M[1]
      }
    })()
    return navigator.browserSpecs
  },
  getCookie (name) {
    var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'))
    return match ? match[1] : null
  },
  deleteCookie (name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
  }
}
